import { render, staticRenderFns } from "./DropifyFile.vue?vue&type=template&id=7d9c3070"
import script from "./DropifyFile.vue?vue&type=script&lang=ts"
export * from "./DropifyFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports